import { useState } from 'react'; 
import { ThemeContext } from '../../../constants/themes';
import Button from '../../atoms/Button';
import Type from '../../atoms/Type';
import TextSubmit from '../TextSubmit';
import { useAuth0 } from "@auth0/auth0-react";
import './index.css';
  
const Authenticator = (props) => {
   const [state, setState] = useState({
      type: props.type || 'signup',
      email: '',
      password: ''
   });

   const { loginWithRedirect } = useAuth0();

   // const authenticate = () => {
   //    // TODO: authenticate
   //    props.onFinish();
   // }

   const onEmailChange = (evt) => {
      setState({
         ...state,
         email: evt.target.value
      })
   }

   const onPasswordChange = (evt) => {
      setState({
         ...state,
         password: evt.target.value
      })
   }

   const switchType = () => {
      if (state.type === 'signup') {
         setState({
            ...state,
            type: 'signin'
         });
      } else if (state.type === 'signin') {
         setState({
            ...state,
            type: 'signup'
         });
      }
   }

   const signUp = () => {
      loginWithRedirect({
         screen_hint: 'signup',
         redirectUri: window.location.origin
      });
   }

   const signIn = () => {
      loginWithRedirect({
         screen_hint: 'signin',
         redirectUri: window.location.origin
      });
   }

   return (
      <ThemeContext.Consumer>
         {themeContext => (
            state.type === "signup" ?
            <div className="authenticatorbigdiv">
               <Type type="h1" style={{margin: 0}}>Welcome to ReadMeThis.</Type>
               <Type>Create an account so that we can send the human recordings you request to your podcast client of choice.</Type>
               <div className="authenticator-selections">
                  <Button value="Sign up" onClick={signUp} style={{marginRight: '1em'}}></Button>
                  <Type>or</Type>
                  <Button type="secondary" value="Sign in" onClick={signIn}></Button>
               </div>
            </div>
            :
            <div className="authenticatorbigdiv">
               <Type type="h1" style={{margin: 0}}>Welcome back.</Type>
               <Type>Sign in so that we can send the human recordings you request to your podcast client of choice.</Type>
               <div className="authenticator-selections">
                  <Button value="Sign in" onClick={signIn} style={{marginRight: '1em'}}></Button>
                  <Type>or</Type>
                  <Button type="secondary" value="Create an account" onClick={signUp}></Button>
               </div>
            </div>
         )}
      </ThemeContext.Consumer>
   );
}
  
export default Authenticator;